import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { abmActions, devActions } from "../../../redux/actions";
import { emptyObject, wait } from "../../../redux/utils";
import { devModeConfig, useDevModeContext } from "../../components/DevMode.helpers";
import { FileProperties } from "./FileProperties";
import { PanelSpinner } from "./PanelSpinner";

export const FilePropertiesWrapper = () => {

  const [ loaded, setLoaded ] = useState(false);
  const { openTab, selectedTab } = useDevModeContext();
  const id = openTab?.data?.metadata?.item?.id;
  const type = openTab?.data?.metadata?.type;
  const devModeContext = useDevModeContext();

  const tabs = useSelector(state => state.dev.tabs);

  useEffect(()=>{
    console.log("refresh openTab", {openTab});
  }, [openTab]);


  const controllerName = useMemo(() => {
    return !!type && devModeConfig[type]?.controllerName;
  }, [type]);

  const dispatch = useDispatch();
  const auth  = useSelector(state => state.auth);
  const snack  = useSelector(state => state.config.snack);
  const controller = useSelector(state => state[controllerName]);
  const configControllers  = useSelector(state => state.config.controllers);
  const config  = useMemo(() => configControllers.find(x => x.name === controllerName), [configControllers, controllerName]);
  const actions = useMemo(() => !!controllerName ? abmActions(controllerName) : emptyObject, [controllerName]);

  useEffect(()=>{
    console.log("cambio controller, configControllers verificacion", {controller, configControllers, controllerName})
  }, [controller, configControllers, controllerName]);

  const connectedActions = useMemo(() => {
    console.log("renueva actions")
    let newActions = {};
    Object.keys(actions).forEach(key => {
      newActions[key] = (param1, params2, param3, param4, param5, param6) => {
          return dispatch(actions[key](param1, params2, param3, param4, param5, param6));
      }
    })
    return newActions;
  }, [actions]);


  useEffect(()=>{
    if(!controller?.schema && !!connectedActions.getSchema){
      connectedActions.getSchema();
    }
  }, [connectedActions?.getSchema, controller?.schema])

  const item = useMemo(() => {
    console.log("creando item", {openTab});
    return {
      ...getExtraParams(openTab?.data?.data || emptyObject), 
      ...(openTab?.data?.data?.value || openTab?.data?.metadata?.item || emptyObject)
    };
  }, [openTab?.data]);


  useEffect(()=>{
    console.log("change id, type", {id, type});
    if(id === undefined || !type) return;
    setLoaded(false);
    const timer = setTimeout(() => {    
      console.log("reloadItem", {id, type});

      if(id===0){
        dispatch(devActions.reloadLocalItem(type, id, openTab?.data?.metadata?.item))
        setLoaded(true);
        return;
      }

      dispatch(devActions.reloadItem(type, id))
        .then(response => {
          setLoaded(true);
        });
    }, 400);
    return () => clearTimeout(timer);
  }, [id, type, openTab?.data?.metadata?.item]);
  
  const finalConfig = useMemo(() => {
    console.log("renueva finalConfig", {config, controller});
    if(!controller?.schema) return emptyObject;
    console.log("schema", {config, controller})
    return {
      ...config, 
      ...(schemaAdapter()[config.name] ? schemaAdapter()[config.name](controller.schema) : emptyObject), 
      columns: config.columnsAsync(controller.schema)
    };
  }, [config, controller?.schema]);

  const handleEditItem = useCallback((id, values, section) => {
    if(!!section){
      return connectedActions.editItem(id, values, section)
    }
    console.log("handleEditItem", {id, values})
    const newValues = valuesAdapter()[controllerName](values, openTab?.data?.data?.value);
    return connectedActions.editItem(id, newValues)
      .then(response => {
        console.log("saved item data response", {response, openTab});
        devModeContext.onSaved().then((selectedTab) => {
          dispatch(devActions.updateTabData(selectedTab, response));
        });
      })
      .catch(e => console.warn(e));
  }, [openTab?.data?.data?.value, controllerName, devModeContext.onSaved]);

  const handleEditItemOrquestador = useCallback((id, values, section) => {
    if(!!section){
      return connectedActions.editItem(id, values, section)
    }
    const newValues = valuesAdapter()[controllerName](values, openTab?.data?.data?.value);
    return connectedActions.editItem(id, newValues)
      .then(response => {
        const flowData = openTab?.data?.data?.value?.flowData;
        const id = openTab?.data?.data?.value?.id;
        console.log("saved item data response (operacion)", {response, openTab, flowData, id});

        if(!flowData) {
          devModeContext.onSaved().then((selectedTab) => {
            dispatch(devActions.updateTabData(selectedTab, response));
          });
          return;
        };

        dispatch(abmActions().postFlow(id, flowData))
          .then(response2 => {
          })
          .catch(error => {
            snack.openAxiosError(error);
          })
          .finally(() => {
            devModeContext.onSaved().then((selectedTab) => {
              dispatch(devActions.updateTabData(selectedTab, response));
            });
          })
      })
      .catch(e => console.warn(e));
  }, [openTab?.data?.data?.value, controllerName]);

  const handleAddItem = useCallback((values, section) => {
    if(!!section){
      return connectedActions.addItem(values, section)
    }
    console.log("handleAddItem", {values});
    const newValues = valuesAdapter()[controllerName](values, openTab?.data?.data?.value);
    return connectedActions.addItem(newValues, section)
      .then(response => {
        console.log("return from save new item", response);
        return dispatch(devActions.postAddItem(openTab, response, type))
        .then(()=>{
          dispatch(devActions.selectNodeFile(`${response.id}-${type}`))
          .then(()=>{
            dispatch(devActions.openTab(`${response.id}-${type}`));;
          })
        })
      }).catch(e => console.warn(e));
  }, [openTab?.data?.data?.value, controllerName]);

  return (
    <>
      {openTab && !!controller?.schema && loaded &&
        <FileProperties 
          lateralForm={"edit"}
          action={"edit"} 
          auth={auth} 
          snack={snack} 
          config={finalConfig}
          {...connectedActions} 
          {...controller} 
          addItem={handleAddItem}
          editItem={controllerName === devModeConfig.operacion.controllerName ? handleEditItemOrquestador : handleEditItem}
          item={item} 
          id={id} 
          controller={controllerName} 
        />
      }
      {!!id && !!type && !loaded && 
        <PanelSpinner />
      }
      {!id && !type && !loaded && 
        <div>nada</div>
      }
    </>
  )

}


const getExtraParams = (data) => {
  return Object.keys(data).reduce((prev, key) => {
    if(key === "value"){
      return prev;
    }
    return {...prev, [key]: data[key].value};
  }, {});
}
console.log(devModeConfig);
const valuesAdapter = () => ({
  [devModeConfig.template.controllerName]: (values, tabData) => {
    return {
      ...values,
      template: tabData?.template || " "
    };
  },
  [devModeConfig.primitiva.controllerName]: (values, tabData) => {
    return {
      ...values,
      templateBodyJson: tabData?.templateBodyJson,
      templateBodyJsonOutput: tabData?.templateBodyJsonOutput,
    };
  },
  [devModeConfig.operacion.controllerName]: (values, tabData) => {
    return values;
  },
  "default": (values) => {
    return values;
  }
})

const schemaAdapter = () => ({
  [devModeConfig.template.controllerName]: (schema) => {
    const result = {
      ...schema,
      fields: schema.fields.map(field => {
        if(field.name === "template"){
          return {
            ...field,
            type: "hidden"
          };
        }else{
          return field;
        }
      })
    }
    console.log("adapter result", result)
    return result;
  },
  [devModeConfig.primitiva.controllerName]: (schema) => {
    return {
      ...schema,
      fields: schema.fields.map(field => {
        if(field.name === "templateBodyJson" || field.name === "templateBodyJsonOutput"){
          return {
            ...field,
            type: "hidden"
          };
        }else{
          return field;
        }
      })
    }
  },
  [devModeConfig.operacion.controllerName]: (schema) => {
    return {
      ...schema,
      fields: schema.fields.map(field => {
        if(field.name === "flow"){
          return {
            ...field,
            type: "hidden"
          };
        }else{
          return field;
        }
      })
    }
  }
})

